import { PlacementTask, PlacementTaskStatus } from '@common/enums';
import { getIsHeraldSubmission, getPlacementTask } from '@common/utils';
import { Box, Stack } from '@common-components';
import { allExpectedSubmissionFileTypes } from 'broker/config/submission-tasks-file-types-config';
import MissingInformationBanner from 'broker/pages/SubmissionWorkspacePage/components/MissingInformationBanner';
import SendSolicitationBanner from 'broker/pages/SubmissionWorkspacePage/components/SendSolicitationBanner';
import useSubmissionMissingFiles from 'broker/pages/SubmissionWorkspacePage/hooks/useSubmissionMissingFiles';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import { getStaticSubmissionMissingOptionalFields, isSubmissionMissingRequiredFields } from 'broker/utils';
import { TasksList } from './components/TasksList';

export default function PreMarketing() {
  const { partialSubmission } = useSubmissionsWorkspace();
  const { getMissingFileTypes, isLoading: isLoadingMissingFiles } = useSubmissionMissingFiles();

  if (!partialSubmission) {
    return null;
  }

  const isMissingRequiredFields = isSubmissionMissingRequiredFields(partialSubmission);

  const isMissingOptionalFields =
    // dynamic application only have required fields
    getIsHeraldSubmission(partialSubmission) || getStaticSubmissionMissingOptionalFields(partialSubmission).length > 0;

  const sendSolicitationTask = getPlacementTask(partialSubmission, PlacementTask.SendSolicitation);
  const shouldShowSolicitationBanner =
    sendSolicitationTask && sendSolicitationTask.status === PlacementTaskStatus.InProgress;

  const isMissingInformation =
    isSubmissionMissingRequiredFields(partialSubmission) ||
    isMissingOptionalFields ||
    getMissingFileTypes(allExpectedSubmissionFileTypes).length > 0;
  const shouldShowMissingInformationBanner = !sendSolicitationTask && isMissingInformation;

  return (
    <Box className="cap-pre-marketing-tab" width={1} overflow="auto" p={0} display="flex">
      <Stack direction="column" flex={1} px={3} pt={2}>
        {shouldShowSolicitationBanner && <SendSolicitationBanner />}
        {shouldShowMissingInformationBanner && (
          <MissingInformationBanner
            isLoadingMissingInformation={isLoadingMissingFiles}
            level={isMissingRequiredFields ? 'error' : 'warning'}
          />
        )}
        <TasksList submission={partialSubmission} getMissingFileTypes={getMissingFileTypes} />
      </Stack>
    </Box>
  );
}
